const LINKS = {
  INSTAGRAM: "https://www.instagram.com/powerking_ind/",
  WHATSAPP: "https://api.whatsapp.com/send?phone=552731031010&text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20coqueteleira%20ORB",
  AMERICANAS: "https://www.americanas.com.br/produto/6523197527?sellerId=36753032000105",
  MERCADOLIVRE: "https://produto.mercadolivre.com.br/MLB-2951556070-coqueteleira-preto-fum-600ml-orb-_JM"
}

export default LINKS